import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AssignmentFilterModel } from 'common/models/page-models/Assignments Model/Assignment Filter Model/assignment-filter-data.model';
import { AssignmentFilterMetaModel } from 'common/models/page-models/Assignments Model/Assignment Filter Model/assignment-filter-meta.model';
import { AssignmentModel } from 'common/models/page-models/Assignments Model/assignment-data.model';
import { AssignmentListingModel } from 'common/models/page-models/Assignments Model/assignment-params.model';
import { WidgetModel } from 'common/models/utility-models/base-model';
import { GridWidgetModel } from 'common/models/utility-models/list-utility.model';

import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { AssignmentGridWidgetService } from 'common/widget/assignment/assignment-grid-widget.service';


@Injectable({
    providedIn: 'root'
})
export class AssignmentGridResolver extends GridResolver<AssignmentModel, AssignmentListingModel> {
    constructor(
        protected fs: AssignmentGridWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);

    }
    override initWidget(envelopeType: any, transferData: any): WidgetModel {
        const widget = new GridWidgetModel();
        const metaModel = this.pageService.getMetaModel();
        widget.recordPerPage = metaModel.properties?.recordPerPage;
        widget.searchableFeilds = metaModel.properties?.searchableFields;
        transferData.filterData = new AssignmentFilterModel();
        transferData.filterMeta = new AssignmentFilterMetaModel().getMetaModel();
         this.fs.getFilterOptions(transferData.filterMeta);
        widget.transferData = transferData;
        return widget;
    }
    
}
